module.exports = __webpack_public_path__ + "static/PAQUETERAS-f65d3d5692db010942631365d9ca9f65.webp";